const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:7071';

export async function fetchSpaList(propertyId) {
  const res = await fetch(`${API_BASE}/api/spa?propertyId=${propertyId}`);
  if (!res.ok) throw new Error('Failed to fetch spa list');
  return await res.json();
}

export async function fetchSingleSpa(id, propertyId) {
  const res = await fetch(`${API_BASE}/api/spa/${id}?propertyId=${propertyId}`);
  if (!res.ok) throw new Error('Failed to fetch spa');
  return await res.json();
}

export async function createSpa(spa) {
  const res = await fetch(`${API_BASE}/api/spa`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(spa)
  });
  if (!res.ok) throw new Error('Failed to create spa');
  return await res.json();
}

export async function updateSpa(id, spa) {
  const res = await fetch(`${API_BASE}/api/spa/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(spa)
  });
  if (!res.ok) throw new Error('Failed to update spa');
  return await res.json();
}

export async function deleteSpa(id, propertyId) {
  const res = await fetch(`${API_BASE}/api/spa/${id}?propertyId=${propertyId}`, {
    method: 'DELETE'
  });
  if (!res.ok) throw new Error('Failed to delete spa');
  return await res.json();
}

export async function reorderSpaList(spaId, massages) {
  const res = await fetch(`${API_BASE}/api/spa/reorder`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ spaId, massages })
  });
  if (!res.ok) throw new Error('Failed to reorder spa list');
  return await res.json();
}

export async function undoSpaDelete(id, propertyId) {
  const res = await fetch(`${API_BASE}/api/spa/undo/${id}?propertyId=${propertyId}`, {
    method: 'POST'
  });
  if (!res.ok) throw new Error('Failed to undo spa delete');
  return await res.json();
}

export async function updateSingleMassage(spaId, massageId, propertyId, update) {
  const res = await fetch(`${API_BASE}/api/spa/${spaId}/massage/${massageId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ propertyId, update })
  });
  if (!res.ok) throw new Error('Failed to update single massage');
  return await res.json();
}

export async function createSingleMassage(spaId, propertyId, newMassage) {
  const res = await fetch(`${API_BASE}/api/spa/${spaId}/massage`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ propertyId, massage: newMassage })
  });
  if (!res.ok) throw new Error('Failed to create single massage');
  return await res.json();
}
export async function deleteSingleMassage(spaId, massageId, propertyId) {
  const res = await fetch(`${API_BASE}/api/spa/${spaId}/massage/${massageId}?propertyId=${propertyId}`, {
    method: 'DELETE'
  });
  if (!res.ok) throw new Error('Failed to delete single massage');
  return await res.json();
}

export async function fetchSpaCategories(propertyId) {
  const res = await fetch(`${API_BASE}/api/spa/categories/${propertyId}`);
  if (!res.ok) throw new Error('Failed to fetch spa categories');
  return await res.json();
}
import axios from 'axios';

export async function fetchSpaPromotions(spaId, propertyId) {
  const res = await axios.get(`${API_BASE}/api/spa-promotions`, {
    params: { spaId, propertyId }
  });
  return res.data;
}

export async function createSpaPromotion(data, spaId, propertyId) {
  const payload = { ...data, spaId, propertyId };
  const res = await axios.post(`${API_BASE}/api/spa-promotions`, payload);
  return res.data;
}

export async function updateSpaPromotion(id, data, spaId, propertyId) {
  const payload = { ...data, spaId, propertyId };
  const res = await axios.patch(`${API_BASE}/api/spa-promotions/${id}`, payload);
  return res.data;
}

export async function deleteSpaPromotion(id, propertyId, spaId) {
  const res = await axios.delete(`${API_BASE}/api/spa-promotions/${id}`, {
    params: { propertyId, spaId }
  });
  return res.data;
}

// ===== Spa Bookings (Admin) =====
// Accepts (propertyId, spaId) OR ({ propertyId, spaId, status, from, to })
export async function fetchSpaBookings(arg1, arg2) {
  const opts = typeof arg1 === 'object' ? arg1 : { propertyId: arg1, spaId: arg2 };
  const { propertyId, spaId, status, from, to } = opts || {};

  const base = `${API_BASE}/api/spa-booking`;
  const url = new URL(base);
  if (propertyId) url.searchParams.set('propertyId', propertyId);
  if (spaId) url.searchParams.set('spaId', spaId);
  if (status && status !== 'all') url.searchParams.set('status', status);
  if (from) url.searchParams.set('from', from);
  if (to) url.searchParams.set('to', to);

  const res = await fetch(url.toString(), { credentials: 'include' });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Failed to fetch spa bookings');
  }
  return await res.json();
}

export async function updateSpaBookingStatus(id, status) {
  const res = await fetch(`${API_BASE}/api/spa-booking/status/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ status }),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Failed to update spa booking status');
  }
  return await res.json();
}

export async function cancelSpaBooking(id, reason) {
  const res = await fetch(`${API_BASE}/api/spa-booking/cancel/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ reason }),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || 'Failed to cancel spa booking');
  }
  return await res.json();
}
// ===== Spa Settings =====
export async function getSpaSettings({ propertyId }) {
  const res = await axios.get(`${API_BASE}/api/spa/settings`, {
    params: { propertyId },
  });
  return res.data;
}

export async function updateSpaSettings({ propertyId, payload }) {
  const res = await axios.put(`${API_BASE}/api/spa/settings`, payload, {
    params: { propertyId },
  });
  return res.data;
}